import { iconIsAvailable } from 'helpers/iconIsAvailable';

const categoryIcons: { [key: number]: string } = {
  // Auto, Motorrad & Zubehör
  21: 'icon-channel-category-automotive',
  // Baumarkt
  22: 'icon-channel-category-hardware-store',
  // Bekleidung
  23: 'icon-channel-category-fashion',
  // Bücher
  25: 'icon-channel-category-books',
  // Büro, Schule & Beruf
  26: 'icon-label-graduate',
  // Consulting
  53: 'icon-channel-category-consulting',
  // Computer, Unterhaltungselektronik & Zubehör
  27: 'icon-channel-category-consumer-electronics',
  // Drogerieartikel & Kosmetik
  28: 'icon-channel-category-cosmetics-and-body-care',
  // Edelmetalle
  29: 'icon-channel-category-gold',
  // Energie
  30: 'icon-channel-category-lighting',
  // Erotik
  31: 'icon-action-favorite-with-heart',
  // Finanzen & Versicherungen
  32: 'icon-channel-category-finance',
  // Floristik
  24: 'icon-channel-category-floristics',
  // Foto, Druck & Book-on-Demand
  33: 'icon-media-image',
  // Gartenbedarf
  34: 'icon-channel-category-gardening',
  // Genussmittel
  54: 'icon-channel-category-luxury-food',
  // Geschenke
  35: 'icon-channel-category-presents',
  // Haushaltswaren & Haushaltsgeräte
  36: 'icon-channel-category-household-appliances',
  // Hobby, Sammeln & Freizeitartikel
  37: 'icon-channel-category-hobby',
  // Karneval & Kostueme
  38: 'icon-channel-category-carnival',
  // Koffer, Taschen & Lederwaren
  39: 'icon-channel-category-suitcase',
  // Lebensmittel
  40: 'icon-channel-category-food',
  // Medikamente
  41: 'icon-channel-category-medicine',
  // Möbel & Dekorationsartikel
  42: 'icon-channel-category-living',
  // Musik & Film
  44: 'icon-channel-category-music',
  // Optiker
  45: 'icon-channel-category-glasses',
  // Reisen & Hotels
  46: 'icon-channel-category-travel',
  // Schmuck & Uhren
  48: 'icon-channel-category-watches-and-jewelry',
  // Schuhe
  49: 'icon-channel-category-shoes',
  // Spielwaren, Baby & Kind
  50: 'icon-channel-category-baby',
  // Sportartikel
  51: 'icon-channel-category-sports-and-outdoor',
  // Telekommunikation
  43: 'icon-label-phone-call',
  // Tickets
  47: 'icon-channel-category-tickets',
  // Tierbedarf
  52: 'icon-channel-category-petsupplies'
};

export const getIconNameForCategoryId = (categoryId: number): string => {
  if (
    !categoryIcons[categoryId] ||
    !iconIsAvailable(categoryIcons[categoryId])
  ) {
    return '';
  }

  return categoryIcons[categoryId];
};
